<section
  class="hero-carousel"
  role="banner"
  [attr.aria-label]="
    stateService.displayState() === 'error'
      ? 'Error cargando ofertas'
      : 'Ofertas destacadas'
  "
  [attr.data-state]="stateService.displayState()"
>
  @switch (stateService.displayState()) { @case ('carousel') {
  <app-hero-carousel-interactive
    [slides]="stateService.slides()"
    (slideClick)="onSlideClick($event)"
  />
  }
  <!--@case ('static') {
  <app-hero-carousel-static
    [slide]="stateService.firstSlide()!"
    [allSlides]="stateService.slides()"
    (slideClick)="onSlideClick($event)"
  />
  } -->
  @case ('skeleton') {
  <!-- Imagen LCP estática solo si hay slides -->
  <!--@if(stateService.hasSlides()){
  <figure
    class="hero-carousel__figure"
    style="margin: 0; padding: 0; width: 100%; height: auto"
  >
    <img
      [src]="stateService.getCurrentSlideImage(stateService.firstSlide())"
      [alt]="stateService.firstSlide().alt || 'Oferta principal'"
      fetchpriority="high"
      loading="eager"
      decoding="sync"
      priority
      style="
        width: 100%;
        height: auto;
        object-fit: cover;
        object-position: center;
      "
      class="hero-carousel__image hero-carousel__image--priority"
    />
  </figure>
  } -->
  <app-hero-carousel-skeleton />
  } @case ('error') {
  <app-hero-carousel-error
    [error]="stateService.error()!"
    (retry)="stateService.retryLoad()"
  />
  } }
</section>
